<template>
    <paper class="sieve-single-center">
        <el-main v-loading="mainLoading" class="main-loading">
            <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :totalTargetData="totalTargetData"
                :totalSuanfaData="totalSuanfaTargetData"
                :sourceRootData="sourceTree"
                :mulSourceSel="true"
                :targetRootData="targetTree"
                :pageTotal="pageTotal"
                :searchTotalTitle="searchTotalTitle"
                :optionNum="optionNum"
                :loading="loading"
                :targetTableLoading="targetTableLoading"
                :verification="verification"
                :sourceTitle="sourceTitle"
                :targetTitle="targetTitle"
                :columnNum="columnNum"
                :isRefreshTarget="true"
                searchId="sieve-single-center-query"
                pageID="sieve-single-center"
                @getTableConfigList="getTableConfigList"
                @allocate-btn="allocateBtn"
                @appointment-btn="appointmentBtn"
                @arrange-btn="arrangeBtn"
                @searchChange="searchChange"
                @root-click="rootClick"
                @source-select-change="sourceSelChange"
                @target-select-change="targetSelChange"
                @search-input="searchInput"
                @sourceCellDblclick="sourceCellDblclick"
                @targetCellDblclick="targetCellDblclick"
                @targetRowClick="targetRowClick"
                @targetSelect="targetSelect"
                @targetSelectAll="targetSelectAll"
                @sourceSelect="sourceSelect"
                @sourceRowClick="sourceRowClick"
                @sourceSelectAll="sourceSelectAll"
                @refreshTarget="refreshTargetList"
                @suanfaSelectChange="suanfaSelectChange"
                @handleEditCount="handleEditCount"
            >
                <span slot="search-list-advance-right">
                    <span
                        v-show="checkedSourceList.length"
                        class="left-info collect"
                    >
                        <span
                            >单量：<span class="content">{{
                                filterCheckedSourceListCount
                            }}</span></span
                        >
                        <span
                            >数量：<span class="content">{{
                                taskTotalCount
                            }}</span></span
                        >
                        <span
                            >方量(m³)：<span class="content">{{
                                taskTotalVolume
                            }}</span></span
                        >
                        <span
                            >重量(KG)：<span class="content">{{
                                taskTotalWeight
                            }}</span></span
                        >
                        <span v-show="totalPkgQtys"
                            >总包件数：<span class="content">{{
                                totalPkgQtys
                            }}</span></span
                        >
                    </span>
                </span>
                <div slot="table-module-btn" class="table-module-btn">
                    <reportExport
                        #default="{ submit }"
                        reportCode="REPORT_SIEVE_SINGLE_CENTER"
                    >
                        <el-tooltip
                            effect="dark"
                            content="导出"
                            placement="bottom"
                        >
                            <span v-has="'otp02010007'" class="mgl-5">
                                <el-button
                                    icon="icon-daochu"
                                    size="mini"
                                    @click="exportFile(submit)"
                                ></el-button>
                            </span>
                        </el-tooltip>
                    </reportExport>
                </div>
                <div slot="target-table-header" class="target-table-header">
                    <DispaHeader
                        :tarSelRoot="tarSelRoot"
                        :mulTotalData="mulTotalData"
                        :realTotalTargetData="realTotalTargetData"
                        :totalTargetData="totalTargetData"
                        :cheList="realCheList"
                        :checkedSourceList="realCheckedSourceList"
                        :transDisable="transferDisable"
                        :confDisable="confirmDisable"
                        :flag="flag"
                        :groupPolicyCode="groupPolicyCode"
                        :groupPolicyValArr="groupPolicyValArr"
                        :sourceTree="sourceTree"
                        :currWarehouseGroup="currWarehouseGroup"
                        :currInOutType="currInOutType"
                        :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                        @newDispOrder="newDispOrder"
                        @leftList="leftList"
                        @intelArr="intelliArrange"
                        @arraVisi="arraVisi"
                        @arrangeConfirmOk="arrangeConfirmOk"
                        @totalDataChange="totalDataChange"
                    >
                    </DispaHeader>
                </div>
                <div
                    slot="target-table-suanfa-header"
                    class="target-suanfa-table-header"
                >
                    <suanfaHeader
                        :tarSelRoot="tarSelRoot"
                        :mulTotalData="mulTotalData"
                        :totalSuanfaTargetData="totalSuanfaTargetData"
                        :checkedSourceList="realCheckedSourceList"
                        :flag="flag"
                        :lineHeaderData="lineHeaderData"
                        :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                        @cancel="cancel"
                        @adjust-btn="adjustBtn"
                        @newDispOrder="newDispOrder"
                        @leftList="leftList"
                        @intelArr="intelliArrange"
                        @arraVisi="arraVisi"
                        @arrangeConfirmOk="arrangeConfirmOk"
                        @totalSuanfaDataChange="totalSuanfaDataChange"
                        @getCarList="getCarList"
                    >
                    </suanfaHeader>
                </div>
                <div slot="expand-table-cont" slot-scope="{ expandTable }">
                    <expand-table-content
                        :contentTableData="expandTable"
                        :columnsList="expandTableHeader"
                    ></expand-table-content>
                </div>
                <div
                    slot="suanfa-expand-table-cont"
                    slot-scope="{ expandTable }"
                >
                    <table-content
                        :contentTableData="expandTable"
                    ></table-content>
                </div>
            </m-pane>
        </el-main>
        <car-scheduling-dialog
            :carrierDisabled="true"
            ref="carScheduling"
            label-position="right"
            :RwCarVisiable.sync="arrangeSubmVisi"
            v-if="arrangeSubmVisi"
            :inOutType="currInOutType"
            :taskDataList="taskDataList"
            @AdmittOk="arrangeSubmOk"
        >
        </car-scheduling-dialog>
        <distribution
            v-if="tableVisible"
            :tableVisible.sync="tableVisible"
            :rowData="rowData"
            ref="distributionRef"
            @distributionOk="distributionOk"
        ></distribution>
        <!-- 预约时间弹窗 -->
        <appointment-time-dialog
            v-if="appointmentTimeDialogVisible"
            :appointmentTimeDialogVisible.sync="appointmentTimeDialogVisible"
            :rowData="rowData"
            @appointmentTimeDialogOk="appointmentTimeDialogOk"
        ></appointment-time-dialog>

        <edit-dialog
            v-if="editDialogVisible"
            :dialogVisible.sync="editDialogVisible"
            :title="title"
            :type="type"
            @handleClose="handleClose"
        ></edit-dialog>
         <!-- 快销预排车 -->
        <quick-cancellation-dialog
            :quickCancellationVisiable.sync="quickCancellationVisiable"
            v-if="quickCancellationVisiable"
            :taskDataList="taskDataList"
            :flag="flag"
            @AdmittOk="arrangeSubmOk"
        >
        </quick-cancellation-dialog>
    </paper>
</template>
<script>
import _ from 'lodash';
import { Sortable } from 'sortablejs';
import mPane from './mPanel';
import config from './sieveSingleConfig.json';
import paper from '@/components/core/paper/Paper';
import ExpandTableContent from '../components/dispatchCenter/ExpandTableContent';
import tableContent from './tableContent';
import { dictWithUrl } from '@/components/lots/api.js';
import {
    getSourceRoot2, getSourceData, getTargetRoot, getTargetData, saveCarArrange, getTransferData,
    intelligentDispatch, getServeRule, recombineAlgorithmLine, getCarListApi, cancelApi, dispatchSave, promptTrackType,getWhiteListApi
} from '../../../api/sieveSingleCenter';
import carSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import { groupPolicyObj, rowCarCheck, addOrderCheck, verifyLBX, verifyLBXOrder, getMesTip, minusVerifyLBXOrder } from '../../../utils/dispatchCenter.js';
import Distribution from './dialog/Distribution';
import AppointmentTimeDialog from './dialog/AppointmentTimeDialog';
import DispaHeader from './sieveSingleHeader';
import suanfaHeader from './suanfaHeader';
import formatTime from '@/utils/common.js';
import reportExport from '@/components/lots/reportExportPlugin';
import EditDialog from '../algorithmParameters/components/EditDialog';
import { mapState } from 'vuex';
import QuickCancellationDialog from '../../../components/dialog/QuickCancellationDialog';

const MAX_SHOW_COUNT = 500; // 默认表格最多只给他展示500条
const TARGER_TABLE_MAX_SHOW_COUNT = 500; // 下面表格给他最多展示的数量
export default {
    name: 'sieveSingleCenter',
    components: { mPane, paper, carSchedulingDialog, ExpandTableContent, Distribution, DispaHeader, reportExport, EditDialog, suanfaHeader, tableContent, AppointmentTimeDialog, QuickCancellationDialog },
    data () {
        return {
            revocationShow: false,
            checkedSourceList: [],
            cheList: [],
            flag: '',
            currentRow: null,
            allocateData: [],
            tableVisible: false,
            tempTargetTree: [],
            config: config,
            loading: false,
            groupPolicy: '',
            groupPolicyCode: '',
            groupPolicyValArr: [],
            targetTableLoading: false,
            sourceTitle: '待调度',
            sourceTree: [],
            targetTree: [],
            sourceSelectedRoot: {},
            tarSelRoot: {},
            targetCanSort: true,
            optionNum: 'DELIVERY_TYPE,TRANSPORT_STATUS,OTP_TMS_PROCUREMENT_CHANNEL',
            totalData: [], // 页面展示的上表格数据
            mulTotalData: [], // 真正的上表格数据
            totalDataFirst: [],
            totalTargetData: [], // 手工排车表格数据
            totalSuanfaTargetData: [], // 算法排车表格数据
            lineHeaderData: {}, // 算法排车头部数据
            cancleData: [], // 算法作废数据
            realTotalTargetData: [], // 真正的下表格数据
            targetIsAllSel: false, // 下表格是否点击全选，因为有天猫优品勾选一单选中所有相同客户订单号只展示100单判断真实选中会不准确
            sourceIsAllSel: false, // 同上，上表格类似逻辑
            pageTotal: 100,
            emergencyMaxNum: '',
            searchParams: {},
            searchTotalTitle: config.table.searchTotalTitle,
            arrangeSubmVisi: false,
            arrangeForm: { procurementChannel: '' },
            verification: {},
            expandTableHeader: [
                { label: '客户商品编码', prop: 'customerItemCode', width: 180 }, { label: '商品编码', prop: 'itemCode', width: 180 },
                { label: '名称', prop: 'itemName', width: 180 }, { label: '商品分类名称', prop: 'itemClassName', width: 180 }, { label: '预计发数量', prop: 'unitQty', width: 100 },
                { label: '商品重量', prop: 'weight', width: 100 }, { label: '商品方量', prop: 'volume', width: 100 }
            ],
            rowData: {},
            mainLoading: false,
            transferDisable: false,
            confirmDisable: false,
            sourceTableDom: '',
            targetTableDom: '',
            targetTotalListPage: {
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            },
            targetTotalListParams: {
                dispatchStatus: '0,6,10,20,30'
            },
            columnNum: 15,
            currentSelectRow: {},
            currentSourceSelectRow: {},
            timerAllDiff: '',
            timerDragLoad: '',
            timerUpDrag: '',
            timerFinalDeliveryType: '',
            isFirstSearch: true,
            serveRule: [],
            editDialogVisible: false,
            title: '编辑',
            type: 'searchEdit',
            LINE_STATUS: {
                0: '未开始',
                10: '进行中',
                20: '排单成功',
                30: '排单失败'
            },
            suanfaSearchFlag: true,
            rowTrainData: {}, // 算法行点击数据
            dispatchSaveFlag: false, // 行排车点击标识
            taskDataList: [],
            appointmentTimeDialogVisible: false,
            quickCancellationVisiable: false,
            appointmentSiteCodeWhiteList: []// 预约强控白名单
        };
    },
    computed: {
         ...mapState({
            supplier: state => state.supplier,
        }),
        realCheckedSourceList: function () {
            if (this.checkedSourceList.length === this.totalData.length && this.sourceIsAllSel) {
                return this.mulTotalData;
            }
            return minusVerifyLBXOrder(this.checkedSourceList, this.mulTotalData);
        },
        realCheList: function () {
            if (this.cheList.length === this.totalTargetData.length && this.targetIsAllSel) {
                return this.realTotalTargetData;
            }
            return minusVerifyLBXOrder(this.cheList, this.realTotalTargetData);
        },
        taskTotalVolume: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 10000) / 10000;
            }, 0);
        },
        filterCheckedSourceListCount: function () {
            return this.realCheckedSourceList.length;
        },
        targetTitle: function () {
            return `待发车(${this.targetTree.length || 0})`;
        },
        currWarehouseGroup: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].warehouseGroup;
        },
        currInOutType: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].inOutType;
        },
        totalPkgQtys: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                if (value.projectClassify === 'HL') {
                    const totalPkgQtys = partical + (value.totalPkgQty || 0);
                    return Math.round(totalPkgQtys * 1000) / 1000;
                }
            }, 0);
        },
    },
    methods: {
        // 导出
        exportFile (submit) {
            let exportParams = {};
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this.searchParams.chooseCode) {
                this.serveRule.forEach(item => {
                    if (item.chooseCode === this.searchParams.chooseCode) {
                        exportParams = item.dispatchCentreRequest;
                    }
                });
            }
            submit({
                ...this.searchParams,
                ...exportParams
            });
            this.isFirstSearch = true;
        },
        handleEditCount () {
            this.editDialogVisible = true;
        },
        handleClose () {
            this.editDialogVisible = false;
        },
        refreshList (visiable) {
            if (visiable) { this[visiable] = false; }
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        leftList () {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        async getDictList () {
            await dictWithUrl(this.optionNum);
        },
        async initTableData (initData) {
            // eslint-disable-next-line max-len
            const dict = await dictWithUrl('OTP_TMS_PROCUREMENT_CHANNEL,TRANSPORT_STATUS,ORDER_TYPE,DELIVERY_TYPE,PROJECT_CLASSIFY,TASK_TYPE,SOURCE_SYSTEM,WMS_STATUS,WDQD,UPSTREAM_SPECIMEN_TYPE,TMS_SHIPPING_TYPE');
            const dictData = dict.data;
            initData.forEach(item => {
                item.supplierReserveFlagName = item.supplierReserveFlag === 'Y' ? '是' : '否';
                item.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                item.distributionFlagName = item.distributionFlag === 'Y' ? '是' : '否';
                item.distributionContinueFlagName = item.distributionContinueFlag === 'Y' ? '是' : '否';
                item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
                item.isJzpName = item.isJzp === 'Y' ? '是' : '否';
                item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
                item.scPosFlagName = +item.scPosFlag === 0 ? '否' : (+item.scPosFlag === 1 ? '是' : item.scPosFlag);
                item.cnDispatchName = +item.cnDispatch === 0 ? '否' : (+item.cnDispatch === 1 ? '是' : item.cnDispatch);
                item.intelligentStatusName = +item.intelligentStatus === 0 ? '未智能调度' : (+item.intelligentStatus === 1 ? '智能调度成功' : '智能调度失败');
                item.planOrderFlagName = +item.planOrderFlag === 1 ? '是' : '否';
                item.logisticModeName = item.logisticMode === 'WT' ? '是' : '否';
                item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus] || item.taskStatus;
                item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || item.orderType;
                if (item.sourceSystem === 'CAINIAO' && item.orderType === 'YS' && +item.serviceType === 8) {
                    item.orderTypeName = '逆向运输';
                }
                item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType] || item.deliveryType;
                item.projectClassifyName = dictData.PROJECT_CLASSIFY[item.projectClassify] || item.projectClassify;
                item.taskTypeName = dictData.TASK_TYPE[item.taskType] || item.taskType;
                item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSystem] || item.sourceSystem;
                item.shippingTypeName = dictData.TMS_SHIPPING_TYPE[item.shippingType] || item.shippingType;
                item.appointmentFlagName = +item.appointmentFlag === 1 ? '是' : '否';
                item.wmsStatusName = dictData.WMS_STATUS[item.wmsStatus] || '待作业';
                item.wdqdName = dictData.WDQD[item.wdqd] || '';
                item.specimenTypeName = dictData.UPSTREAM_SPECIMEN_TYPE[item.specimenType] || '';
                item.restrictFlagName = +item.restrictFlag === 1 ? '是' : '否';
                if (item.transportDetails && item.transportDetails.length > 0) {
                    const splitArr = item.transportDetails[0].itemClassName ? item.transportDetails[0].itemClassName.split('.') : [];
                    splitArr.shift();
                    item.itemClassName = splitArr.join('.');
                }
                item.arriveAppointmentRequireFlagName = +item.arriveAppointmentRequireFlag === 3 ? '是' : '否';
            });
            return initData;
        },
        initDispatchList () {
            if (+this.tarSelRoot.intelligentStatus === 10) this.$refs.tablePage.$refs.searchList.onSearchChange();
            this.$refs.tablePage.targetLoading = true;
            const params = { dispatchNo: this.tarSelRoot.dispatchNo, ...this.targetTotalListPage };
            getTargetData(params).then(async res => {
                if (res) {
                    this.realTotalTargetData = await this.initTableData(res.data.list || []);
                    this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                }
            }).finally(() => {
                this.$refs.tablePage.targetLoading = false;
            });
        },
        initTransportList (scroll) {
            this.$refs.tablePage.sourceLoading = true;
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    this.groupPolicyCode = item.code;
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            getSourceData(data).then(async resp => {
                this.$refs.tablePage.sourceLoading = false;
                if (resp) {
                    this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                    const resData = resp.data.list || [];
                    if (this.sourceSelectedRoot.isActive) {
                        this.mulTotalData = this.mulTotalData.concat(resData);
                    } else {
                        const resDataGroupPolicyCode = resData.map(el => el[this.groupPolicyCode]);
                        this.mulTotalData = this.mulTotalData.filter(el => !resDataGroupPolicyCode.includes(el[this.groupPolicyCode]));
                    }
                    let btnCount = 0;
                    const totalTargetDataTaskNo = this.realTotalTargetData.map(el => el.taskNo);
                    this.mulTotalData = this.mulTotalData.filter(el => !totalTargetDataTaskNo.includes(el.taskNo));
                    this.mulTotalData = await this.initTableData(this.mulTotalData);
                    this.mulTotalData.forEach((subItem, subIndex) => {
                        if ((subItem.orderType === 'RI') && ['IN', 'DI', 'RDI'].includes(subItem.taskType)) {
                            subItem.hiddenEvent = ['allocate'];
                        } else {
                            btnCount++;
                            subItem.hiddenEvent = [];
                        }
                    });
                    this.config.table.leftOperation = !!btnCount;
                    this.totalData = this.getTotalData(this.mulTotalData);
                }
            }).catch(() => {
                this.$refs.tablePage.sourceLoading = false;
            });
        },
        rowDrop () {
            const sourceTbody = document.querySelector(
                '.source-table .el-table__body-wrapper tbody'
            );
            const _this = this;
            this.sortInst = Sortable.create(sourceTbody, {
                group: {
                    name: 'source',
                    pull: true,
                    put: 'target' // 可拖出
                },
                sort: false, // 禁止表内排序
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldSourceInx = oldIndex;
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldSourceInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldSourceInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldSourceInx - 1;
                            }
                        }
                        item.remove();
                        const rows2Transfer = _this.realCheckedSourceList.length > 1 ? _this.realCheckedSourceList : [_this.totalData[oldIndex]];
                        const clone = _this.totalData;
                        _this.totalData = [];
                        for (let i = 0; i < rows2Transfer.length; i++) {
                            let warningMsg = '';
                            if (this.isPrivilege && rows2Transfer[i].logisticMode === 'WT' && rows2Transfer[i].scanNum > 0) {
                                warningMsg = '直通宝已扫码，请在直通宝完成后续操作';
                            } else if (rows2Transfer.some(row => +row.arriveAppointmentRequireFlag === 2 && !row.appointmentTime)) {
                                warningMsg = '存在强制预约的客户订单，需要预约派送时间!';
                            };
                            if (warningMsg) {
                                _this.timerAllDiff = setTimeout(() => {
                                    _this.$nextTick(() => {
                                        _this.totalData = clone;
                                    });
                                }, 100);
                                return this.$message.warning(warningMsg);
                            }
                        }
                        const realTotalData = this.mulTotalData;
                        let rowCarCheckRes = '';
                        const verifyLBXRes = verifyLBX(rows2Transfer, realTotalData);
                        clearTimeout(_this.timerAllDiff);
                        clearTimeout(_this.timerDragLoad);
                        if (_this.realTotalTargetData.length <= 0) {
                            rowCarCheckRes = rowCarCheck(rows2Transfer);
                        } else {
                            rowCarCheckRes = rowCarCheck(_this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = rowCarCheck(rows2Transfer, _this.realTotalTargetData[0], _this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(_this.realTotalTargetData, rows2Transfer);
                        }
                        _this.timerAllDiff = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (rowCarCheckRes) {
                                    _this.totalData = clone;
                                    return _this.$message.warning(rowCarCheckRes);
                                } else if (_.isPlainObject(verifyLBXRes)) {
                                    _this.totalData = clone;
                                    return getMesTip(verifyLBXRes, _this);
                                } else {
                                    _this.realTotalTargetData = [
                                        ...verifyLBXRes,
                                        ..._this.realTotalTargetData
                                    ];
                                    _this.totalTargetData = this.getTotalData(_this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                    const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                                    this.mulTotalData = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                                    _this.totalData = this.getTotalData(this.mulTotalData);
                                }
                            });
                        }, 100);
                    }
                }
            });
            const targetTbody = document.querySelector(
                '.target-table .el-table__body-wrapper tbody'
            );
            Sortable.create(targetTbody, {
                group: {
                    name: 'target',
                    pull: true,
                    put: 'source' // 可放置来自source组的拖拽
                },
                sort: false,
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldTargetInx = oldIndex;
                    this.groupPolicyValArr = [];
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldTargetInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldTargetInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldTargetInx - 1;
                            }
                        }
                        const targetTabelData = _this.realCheList.length > 1 ? _this.realCheList : [_this.totalTargetData[oldIndex]];
                        const targetClone = _this.totalTargetData;
                        _this.totalTargetData = [];
                        clearTimeout(this.timerUpDrag);
                        this.timerUpDrag = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (+this.tarSelRoot.gainingContract) {
                                    _this.$message.warning('获取合同号中，不可以加单');
                                    _this.totalTargetData = targetClone;
                                } else {
                                    for (let i = 0; i < targetTabelData.length; i++) {
                                        if (targetTabelData[i].logisticMode !== 'WT' &&+targetTabelData[i].taskStatus === 30 && targetTabelData[i].dispatchNo && ['YS', 'OUT'].includes(targetTabelData[i])) {
                                            _this.totalTargetData = targetClone;
                                            return this.$message.warning(`存在不能减单的运输单：${targetTabelData[i].taskNo}`);
                                        }
                                         if (this.isPrivilege && targetTabelData[i].logisticMode === 'WT' && targetTabelData[i].taskStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                                            return this.$message.warning(`仓配分离运输单：${targetTabelData[i].taskNo} 是在途前的状态才能减单`);
                                        }
                                    }
                                    const minusVerifyLBXOrderRes = minusVerifyLBXOrder(targetTabelData, this.realTotalTargetData);
                                    const targetDataTaskNo = minusVerifyLBXOrderRes.map(el => el.taskNo);
                                    this.realTotalTargetData = this.realTotalTargetData.filter(el => !targetDataTaskNo.includes(el.taskNo));
                                    _this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                    const currentGroupPolicyData = []; // 在当前分组下要拖的数据
                                    this.groupPolicyValArr = [];
                                    // 多选功能下选中的待调度的分组
                                    this.sourceTree.forEach(item => {
                                        if (item.isActive) this.groupPolicyValArr.push(item[this.groupPolicyCode]);
                                    });
                                    minusVerifyLBXOrderRes.forEach(item => {
                                        if (this.groupPolicyValArr.includes(item[this.groupPolicyCode])) currentGroupPolicyData.push(item);
                                    });
                                    const curGrototalDataClone = [].concat(_this.mulTotalData);
                                    const targetTabelTask = curGrototalDataClone.map(el => el.taskNo);
                                    currentGroupPolicyData.forEach(item => {
                                        if (this.groupPolicyValArr.length === 0) {
                                            _this.mulTotalData = [];
                                        } else if (this.groupPolicyValArr.includes(item[this.groupPolicyCode]) && !targetTabelTask.includes(item.taskNo)) {
                                            _this.mulTotalData.unshift(item);
                                        }
                                    });
                                    _this.totalData = this.getTotalData(_this.mulTotalData);
                                }
                            });
                        }, 80);
                    }
                }
            });
        },
        getTotalData (totalData, maxShowCount = MAX_SHOW_COUNT) {
            const maxCountNum = this.emergencyMaxNum || maxShowCount;
            if (totalData.length < maxCountNum) {
                return totalData;
            }
            return totalData.slice(0, maxCountNum);
        },
        emergencyMaxNumChange (value) {
            this.leftList();
            this.emergencyMaxNum = value;
        },
        async searchChange (data) {
            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime && !data.beginDate) {
                data.beginDate = '';
                data.endDate = '';
            }
            if (data.departureTime && data.departureTime.length > 0) {
                data.beginDate1 = data.departureTime[0];
                data.endDate1 = data.departureTime[1];
            } else if (!data.departureTime && !data.beginDate1) {
                data.beginDate1 = '';
                data.endDate1 = '';
            }
            if (data.requireArriveTime && data.requireArriveTime.length > 0) {
                data.requireArriveTimeBegin = data.requireArriveTime[0];
                data.requireArriveTimeEnd = data.requireArriveTime[1];
            } else if (!data.requireArriveTime && !data.requireArriveTimeBegin) {
                data.requireArriveTimeBegin = '';
                data.requireArriveTimeEnd = '';
            }

            if (data.custOrderNo) {
                data.custOrderNos = data.custOrderNo.split(',');
            } else {
                data.custOrderNos = '';
            }
            if (data.waveId) {
                data.waveIdList = data.waveId.split(',');
            } else {
                data.waveIdList = '';
            }
            if (data.waveIdList.length > 100) {
                return this.$message.warning('最多只允许操作100个波次号进行查询')
            }
            delete data.waveId;
            delete data.custOrderNo;
            delete data.createTime;
            delete data.departureTime;
            delete data.requireArriveTime;
            delete data.requireArriveTime;
            const startTime = data.beginDate || 0;
            const endTime = data.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!data.custOrderNos.length && !startTime) {
                return this.$message.warning('客户订单号 和 创建时间 不可同时为空');
            } else if (!data.custOrderNos.length && startTime) {
                if (timeDifference > 63 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过两个月！');
                }
            }
            if (data.appointmentTimeReleased && !(/^[1-9]\d*$/).test(data.appointmentTimeReleased)) {
                return this.$message.warning('预约释放时间只能填正整数！');
            }
            this.totalData = [];
            this.mulTotalData = [];
            if (data.groupPolicy) this.groupPolicy = data.groupPolicy;
            data.taskStatus = '0';
            this.searchParams.carrierVisibleFlag = 'Y';
            this.searchParams.carrierCodes = [this.supplier.supplierCode];
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            if (this.searchParams.querySiteCode) {
                this.searchParams.querySiteCodes = this.searchParams.querySiteCode.split(',');
            } else {
                this.searchParams.querySiteCodes = [];
            }
            for (const key in this.searchParams) {
                if (!this.searchParams[key].length) {
                    delete this.searchParams[key];
                }
            }
            for (const key in this.searchParams) {
                if (key !== 'chooseCode' && key !== 'beginDate' && key !== 'endDate' && key !== 'taskStatus' && key !== 'groupPolicy' && key !== 'appointmentTimeReleased'&& key !== 'carrierVisibleFlag'&& key !== 'carrierCodes') {
                    delete this.searchParams.chooseCode;
                }
            }
            this.isFirstSearch = false;
            this.$refs.tablePage.changeLoading(true);
            this.$refs.tablePage.sourceTreeLoading = true;
            this.$refs.tablePage.targetTreeLoading = true;
            await getSourceRoot2(this.searchParams).then(resp => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
                if (resp) {
                    const sourceTree = resp.data.list;
                    if (sourceTree) {
                        sourceTree.forEach(root => {
                            root.isActive = false;
                            root['textLeft'] =
                                `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '}
                            ${Math.round(root.totalVolume * 100) / 100 || '0.00'}m³/${root.totalWeight || ''}KG/${root.totalQty || ''}台/${root.taskCount || ''}单`;
                        });
                    }
                    this.sourceTree = sourceTree;
                }
            }).catch(() => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
            });
            await this.getTargetList();
            this.$refs.tablePage.initActiveChange();
            if (this.suanfaSearchFlag) {
                this.getCarList();
            }
            this.suanfaSearchFlag = false;
        },
        async getCarList () {
            this.lineHeaderData = {};
            this.totalSuanfaTargetData = [];
            this.$refs.tablePage.suanfaLoading = true;
            const params = {
                lineCode: this.lineCode || ''
            };
            const dict = await dictWithUrl('TRAIN_STATUS,TRANSPORT_STATUS');
            const dictData = dict.data;
            getCarListApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.lineHeaderData = res.data.lineHeader;
                    this.lineHeaderData.lineStatusName = this.LINE_STATUS[+this.lineHeaderData.lineStatus] || '';
                    this.totalSuanfaTargetData = res.data.lineDetailResponses || [];
                    this.totalSuanfaTargetData.forEach(item => {
                        item.hiddenEvent = [];
                        item.dispatchStatusName = item.dispatchStatus ? dictData.TRAIN_STATUS[item.dispatchStatus] : '';
                        item.volumeRates = Math.round((item.volumeRate + Number.EPSILON) * 10000) / 100 + '%';
                        item.lineOrderResponseList.forEach(i => {
                            i.planOrderFlagName = +i.planOrderFlag === 1 ? '是' : '否';
                            i.restrictFlagName = ['否', '是'][i.restrictFlag] || '';
                        });
                    });
                }
            }).finally(() => {
                this.$refs.tablePage.suanfaLoading = false;
            });
        },
        // 算法选中行
        suanfaSelectChange (data) {
            this.cancleData = data;
        },
        // 车次行点击排车
        arrangeBtn (data) {
            this.dispatchSaveFlag = true;
            this.rowTrainData = data;
            this.taskDataList = data.lineOrderResponseList || [];
              // 快销判断，特殊排车
            if (this.taskDataList.some(i => i.projectClassify === 'QCO')) {
                this.flag = '2';// 为了快消单走算法预排保存时调用原有接口
                this.quickCancellationVisiable = true;
                return false;
            }
            this.arrangeSubmVisi = true;
            const params = {
                carrierName: this.taskDataList[0].carrierName,
                carrierCode: this.taskDataList[0].carrierCode,
                supplierCode: this.taskDataList[0].carrierCode,
                transType: this.taskDataList[0].procurementChannel,
                tranName: this.taskDataList[0].procurementChannelName,
                siteCode: this.taskDataList[0].siteCode,
                transUnitName: this.taskDataList[0].transUnitName,
                transUnitCode: this.taskDataList[0].transUnitCode,
                routeNoList: this.taskDataList.filter(item => item.lineCode).map(item => item.lineCode)
            };
            this.$nextTick(() => {
                this.$refs.carScheduling.AdmittRuleForm.carrierName = this.taskDataList[0].carrierName;
                this.$refs.carScheduling.AdmittRuleForm.companyCode = this.taskDataList[0].companyCode;
                this.$refs.carScheduling.getAdvanceValueLists(params);
            });
        },
        // 行调整
        adjustBtn () {
            if (this.cancleData.length === 0) return this.$message.warning('请至少勾选一条数据');
            const lineCodeSet = new Set(this.cancleData.map(t => t.lineCode));
            if (lineCodeSet.size !== 1) {
                return this.$message.warning('只有同一排单下的车次才可以进行车次间调整');
            }
            const trainNums = this.cancleData.map(i => i.trainNum).join(',');
            this.$router.push({
                query: { trainNums: trainNums },
                path: '/otp/dispatch-Manage/train-list-adjust'
            });
        },
        // 加入算法
        totalSuanfaDataChange (targetData, sourceData) {
            let lineDetailList = [];
            if (this.totalSuanfaTargetData && this.totalSuanfaTargetData.length) {
                lineDetailList = this.totalSuanfaTargetData.map(item => { return { id: item.id }; });
            }
            const params = {
                rollbackLineCode: this.lineHeaderData ? this.lineHeaderData.lineCode : '',
                lineDetailList: lineDetailList,
                transportList: targetData.map(item => { return { taskNo: item.taskNo }; })
            };
            recombineAlgorithmLine(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('加入算法成功');
                    this.mulTotalData = sourceData;
                    this.lineCode = res.data;
                    setTimeout(() => {
                        this.getCarList();
                    }, 2000);
                    this.totalData = this.getTotalData(sourceData);
                }
            });
        },
        cancel () {
            if (!this.cancleData.length) {
                return this.$message.warning('至少先选择一条数据');
            }
            cancelApi(this.cancleData).then(res => {
                if (res && +res.data.code === 0) {
                    this.getCarList();
                    this.$message.success('作废成功');
                    this.lineHeaderData = {};
                    this.totalSuanfaTargetData = [];
                } else {
                    this.$message.warning(`${res.data.msg}`);
                }
            });
        },
        async getTargetList (isClick) {
            this.$refs.tablePage.targetTreeLoading = true;
            this.targetTotalListParams.carrierCode = this.supplier.supplierCode;
            await getTargetRoot(this.targetTotalListParams).then(res => {
                this.$refs.tablePage.targetTreeLoading = false;
                if (res) {
                    const targetTree = res.data.list || [];
                    if (targetTree) {
                        targetTree.forEach(root => {
                            if (+root.intelligentFlag !== 0) {
                                if (+root.intelligentStatus === 10) {
                                    root['html'] = `<span class="left-doted"> 智能排车中...`;
                                } else {
                                    root['html'] = `<span class="left-doted">${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                                }
                            } else {
                                root['html'] = `${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                            }
                        });
                    }
                    this.targetTree = this.tempTargetTree = targetTree;
                    if (isClick) {
                        this.$nextTick(() => {
                            this.targetTree[0] && this.$refs.tablePage.rootListClick(this.targetTree[0], 'target', 0);
                        });
                    }
                    setTimeout(() => {
                        this.autoSearchInput && this.autoSearchInput();
                        this.autoSearchInput = null;
                        this.againActivated = true;
                    }, 100);
                }
            }).catch(() => {
                this.$refs.tablePage.targetTreeLoading = true;
            });
        },
        getTableConfigList (data) { },
        rootClick (item, to) {
            if (to === 'source') {
                this.sourceSelectedRoot = item;
                this.initTransportList();
            }
            if (to === 'target') {
                this.tarSelRoot = item;
                if (+this.tarSelRoot.intelligentStatus === 10) {
                    this.transferDisable = this.confirmDisable = true;
                } else if (+this.tarSelRoot.intelligentStatus === 30) {
                    this.transferDisable = this.confirmDisable = false;
                }
                this.initDispatchList();
            }
        },
        sourceSelChange (selection) {
            this.checkedSourceList = selection;
            const selctedTaskNos = this.checkedSourceList.map(item => item.taskNo);
            this.currentSourceSelectRow.checked = selctedTaskNos.includes(this.currentSourceSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSourceSelectRow, moduleTable);
        },
        sourceSelectAll (selection) {
            this.sourceIsAllSel = true;
        },
        sourceSelect (selection, row) {
            this.sourceIsAllSel = false;
            this.currentSourceSelectRow = row;
        },
        sourceRowClick (row) {
            this.sourceIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        targetSelChange (selection) {
            this.cheList = selection;
            const selctedTaskNos = this.cheList.map(item => item.taskNo);
            this.currentSelectRow.checked = selctedTaskNos.includes(this.currentSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSelectRow, moduleTable);
        },
        targetSelect (selection, row) {
            this.targetIsAllSel = false;
            this.currentSelectRow = row;
        },
        targetSelectAll (selection) {
            this.targetIsAllSel = true;
        },
        checkSameLbxOrder (row, moduleTable) {
            // 天猫优品的单勾选一条相同客户订单号的全部选中（展示中的数据）
            if (row.businessMode === 'B2B' && ['OUT', 'DO'].includes(row.taskType) && row.sourceSystem === 'CAINIAO') {
                const sameLbxOrder = moduleTable.tableData.filter(item => item.customerOrderNo === row.customerOrderNo);
                sameLbxOrder.forEach(item => {
                    moduleTable.toggleRowSelection(item, row.checked);
                });
            }
        },
        targetRowClick (row) {
            this.targetIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        intelliArrange () {
            if (this.realTotalTargetData.length) {
                if (this.realTotalTargetData.some(el => el.isIntelliFailed)) {
                    // 智能排车失败标志
                    this.$message.warning('存在请求智能排车的失败数据，不能进行二次智能排车');
                    return;
                }
                if (this.realTotalTargetData.find(el => +el.planOrderFlag === 1)) return this.$message.warning('不支持模糊订单智能排车，有问题请联系郑右云');
                this.$refs.tablePage.targetLoading = true;
                const params = {
                    biz: 'vrp',
                    transportList: this.realTotalTargetData
                };
                intelligentDispatch(params).then(res => {
                    this.$refs.tablePage.targetLoading = false;
                    if (res) {
                        this.$message.success('已提交');
                        this.leftList();
                    }
                }).catch(() => {
                    this.$refs.tablePage.targetLoading = false;
                });
            } else {
                this.$message.warning('请至少选择一条运输单');
            }
        },
        handleArrangeClose () {
            this.arrangeSubmVisi = false;
        },
        arrangeSubmOk (data) {
            if (data.state) {
                if (this.dispatchSaveFlag) {
                    data = Object.assign({}, data.data);
                    data.preDispatchType = '2';
                    data.trainNum = this.rowTrainData.trainNum; // 车次号
                    dispatchSave(data).then(res => {
                        if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                        if (res && +res.code === 0) {
                            const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                            if (data.procurementChannel === '190') {
                                this.$router.push({
                                    name: 'dispatchOrder',
                                    params: { name: '/dispatch-order', dispatchNo: genDispatchNo, carrierName: data.carrierName }
                                });
                            }
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                message: `<div>
                                    <span>已保存，生成发车单号：${res.data}</span>
                                    <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                </div>`,
                                type: 'success',
                                duration: 5000
                            });
                            this.arrangeSubmVisi = false;
                            this.dispatchSaveFlag = false;
                            this.quickCancellationVisiable = false;
                            document.getElementById('copyNo').addEventListener('click', () => {
                                this.copyText(document.body, genDispatchNo, false);
                            });
                            if (data.vehicleCard && data.vehicleCard !== '*') {
                                this.getPromptTrackType(genDispatchNo);
                            }
                            this.getCarList();
                        } else if (+res.code === 200) {
                            this.arrangeSubmVisi = false;
                            this.$message.error(res.msg || '');
                        }
                    }).catch(() => {
                        this.mainLoading = false;
                        if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                    });
                } else {
                    if (data.data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                        this.arrangeSubmVisi = true;
                        this.$refs.carScheduling.saveLoading = true;
                    }
                    if (+this.flag === 2) {
                        const obj = {
                            flag: +this.flag,
                            oldDispatchNo: this.tarSelRoot.dispatchNo,
                            dispatchStatus: this.tarSelRoot.dispatchStatus,
                            transportList: this.realCheList,
                            preDispatchType: '2', // 调度类型
                            operateEntrance: 'LSP',
                            ...data.data
                        };
                        obj.transportList.forEach(item => {
                            item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                        });
                        getTransferData(obj).then(res => {
                            if (obj.preDispatchStrategy !== 'FMCG') { // 不是快消单
                                this.$refs.carScheduling.saveLoading = false;
                            }
                            if (res) {
                                if (res.msg === 'Success') {
                                    this.$message({
                                        dangerouslyUseHTMLString: true,
                                        message: `<div>
                                                    <span>转移成功，生成发车单号：${res.data}</span>
                                                    <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                                </div>`,
                                        type: 'success',
                                        duration: 5000
                                    });
                                } else {
                                    this.$message({
                                        dangerouslyUseHTMLString: true,
                                        message: `<div>
                                                <span>${res.msg}</span>
                                                <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                            </div>`,
                                        showClose: true,
                                        type: 'success',
                                        duration: 5000
                                    });
                                }
                                const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                                document.getElementById('copyTraNo').addEventListener('click', () => {
                                    this.copyText(document.body, genDispatchNo, false);
                                });
                                this.arrangeSubmVisi = false;
                                this.quickCancellationVisiable = false;
                                if (obj.vehicleCard && obj.vehicleCard !== '*') {
                                    this.getPromptTrackType(genDispatchNo);
                                }
                                this.leftList();
                            }
                        }).catch(() => {
                            if (obj.preDispatchStrategy !== 'FMCG') { // 不是快消单
                                this.$refs.carScheduling.saveLoading = false;
                            }
                        });
                    } else {
                        this.mainLoading = true;
                        data = Object.assign({}, data.data, this.tarSelRoot);
                        data.transportList = this.realTotalTargetData;
                        data.preDispatchType = '2';
                        data.transportList.forEach(item => {
                            item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                        });
                        saveCarArrange(data).then(res => {
                            this.mainLoading = false;
                            if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                                this.$refs.carScheduling.saveLoading = false;
                            }
                            if (res && +res.code === 0) {
                                const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                                if (data.procurementChannel === '190') {
                                    this.$router.push({
                                        name: 'dispatchOrder',
                                        params: { name: '/dispatch-order', dispatchNo: genDispatchNo, carrierName: data.carrierName }
                                    });
                                }
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: `<div>
                                    <span>已保存，生成发车单号：${res.data}</span>
                                    <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                </div>`,
                                    type: 'success',
                                    duration: 5000
                                });
                                this.arrangeSubmVisi = false;
                                this.quickCancellationVisiable = false;
                                document.getElementById('copyNo').addEventListener('click', () => {
                                    this.copyText(document.body, genDispatchNo, false);
                                });
                                if (data.vehicleCard && data.vehicleCard !== '*') {
                                    this.getPromptTrackType(genDispatchNo);
                                }
                                this.leftList();
                            } else if (+res.code === 200) {
                                this.arrangeSubmVisi = false;
                                this.$message.error(res.msg || '');
                                this.leftList();
                            }
                        }).catch(() => {
                            this.mainLoading = false;
                            if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                                this.$refs.carScheduling.saveLoading = false;
                            }
                        });
                    }
                }
            }
        },
        getPromptTrackType (dispatchNo){
            promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data && +res.data.shippingType === 1) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    } else {
                        this.$message.warning('未知车辆北斗入网状态，请要求司机全程打开直通宝');
                    }
                }
            });
        },
        searchInput (input, ev, isClick) {
            const inputVal = input.trim();
            const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
            if (!inputVal) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = '';
            } else if (reg.test(inputVal)) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = inputVal;
            } else {
                this.targetTotalListParams.dispatchNo = inputVal;
                this.targetTotalListParams.vehicleCard = '';
            }
            this.getTargetList(isClick);
        },
        async arrangeConfirmOk (dispatchNo) {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.tarSelRoot = {};
            await this.searchChange(this.searchParams);
            this.$refs.tablePage.isCondition = true;
            this.$refs.tablePage.isShowImg = false;
            this.$refs.tablePage.input = dispatchNo;
            this.targetTree = this.tempTargetTree.filter(item => {
                return (item.dispatchNo && item.dispatchNo.indexOf(dispatchNo.trim()) !== -1);
            });
            if (this.targetTree.length === 0) {
                this.$refs.tablePage.input = null;
                this.targetTree = this.tempTargetTree;
            }
        },
        allocateBtn (data) {
            this.rowData = Object.assign({}, data);
            const verifyLBXOrderRes = verifyLBXOrder([data]);
            if (!getMesTip(verifyLBXOrderRes, this)) { this.tableVisible = true; }
        },
        distributionOk () {
            this.tableVisible = false;
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        appointmentBtn (data) {
            this.rowData = Object.assign({}, data);
            this.appointmentTimeDialogVisible = true;

        },
        appointmentTimeDialogOk () {
            this.appointmentTimeDialogVisible = false;
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        newDispOrder () {
            this.tarSelRoot = {};
            this.totalTargetData = [];
            this.realTotalTargetData = [];
        },
        arraVisi (val) {
            // val有值 是移交dialog 里面选了 新建发车单 然后点击确定按钮,这个时候taskDataList等于下表格选中的数据，否则是下表格所有的数据
            this.taskDataList = val ? this.realCheList : this.realTotalTargetData;
            this.dispatchSaveFlag = false;
             // 快销判断，特殊排车
            if (this.taskDataList.some(i => i.projectClassify === 'QCO')) {
                this.quickCancellationVisiable = true;
                return false;
            }
            // carrierVisibleFlag !== 'Y'是点了排车, 但未下发供应商
            if (val || this.realTotalTargetData[0].carrierVisibleFlag !== 'Y') {
                this.arrangeSubmVisi = true;
                this.$nextTick(() => {
                    this.$refs.carScheduling.AdmittRuleForm.companyCode = this.realTotalTargetData[0].companyCode;
                    this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.realTotalTargetData.filter(item => item.lineCode).map(item => item.lineCode);
                    this.$refs.carScheduling.$refs.carrierName.show();
                });
                this.flag = val;
                return false;
            }
            const flag = this.realTotalTargetData.find((item, index, arr) => item.carrierCode !== arr[0].carrierCode);
            if (flag) {
                this.$message.warning('同一承运商的运单才能排车');
                return false;
            }
            // 点击了排车，已下发供应商
            this.arrangeSubmVisi = true;
            const params = {
                carrierName: this.realTotalTargetData[0].carrierName,
                carrierCode: this.realTotalTargetData[0].carrierCode,
                supplierCode: this.realTotalTargetData[0].carrierCode,
                transType: this.realTotalTargetData[0].procurementChannel,
                tranName: this.realTotalTargetData[0].procurementChannelName,
                siteCode: this.realTotalTargetData[0].siteCode,
                transUnitName: this.realTotalTargetData[0].transUnitName,
                transUnitCode: this.realTotalTargetData[0].transUnitCode,
                paymentTerms: this.realTotalTargetData[0].paymentTerms,
                transportContractNo: this.realTotalTargetData[0].transportContractNo,
                routeNoList: this.realTotalTargetData.filter(item => item.lineCode).map(item => item.lineCode)
            };
            this.$nextTick(() => {
                this.$refs.carScheduling.AdmittRuleForm.carrierName = this.realTotalTargetData[0].carrierName;
                this.$refs.carScheduling.AdmittRuleForm.companyCode = this.realTotalTargetData[0].companyCode;
                this.$refs.carScheduling.getAdvanceValueLists(params);
            });
        },
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        sourceCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        targetCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        totalDataChange (targetData, sourceData, scrollFlag) {
            this.mulTotalData = sourceData;
            this.realTotalTargetData = targetData;
            this.totalTargetData = this.getTotalData(targetData, TARGER_TABLE_MAX_SHOW_COUNT);
            this.totalData = this.getTotalData(sourceData);
        },
        refreshTargetList () {
            this.totalTargetData = [];
            this.targetTotalListParams.dispatchNo = this.targetTotalListParams.vehicleCard = '';
            this.getTargetList();
            this.$refs.tablePage.initActiveChange();
        },
        getServeRules () {
            getServeRule({}).then(res => {
                if (res && +res.code === 0) {
                    this.serveRule = res.data || [];
                    const option = [];
                    res.data.forEach(item => {
                        option.push({ 'value': item.chooseCode, 'label': item.chooseName });
                    });
                    this.config.searchList.searchTxt[1].options = option;
                }
            });
        },
        async getSiteCodeWhiteList ({ type }) {
            await getWhiteListApi({ type }).then(res => {
                if (res && +res.code === 0) {
                    this.appointmentSiteCodeWhiteList = res.data;
                }
            });
        }
    },
    mounted () {
        this.getDictList();
        // 获取筛单规则;
        this.getServeRules();
        this.rowDrop();
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
        // 强制预约限制白名单
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
    },
    activated () {
        // 获取筛单规则
        this.getServeRules();
        // 强制预约限制白名单
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
        const dispatchNo = this.$route.params.dispatchNo;
        if (dispatchNo) {
            const tablePage = this.$refs.tablePage;
            tablePage.showInput();
            this.autoSearchInput = () => {
                tablePage.input = dispatchNo;
                tablePage.searchInput(null, true);
            };
            if (this.againActivated) {
                this.autoSearchInput();
                this.autoSearchInput = null;
            }
        };
    }
};
</script>
<style lang="less">
@import './sieveSingleCenter.less';
</style>
